<script setup>
import { computed } from "vue";
import Button from "@/shared/ui/button/Button.vue";
import { Input } from "@/shared/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/ui/select";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  sortValue: {
    type: String,
    required: true,
  },
  statusOptions: {
    type: Array,
    default: () => [],
  },
  templateCategories: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits([
  "update:modelValue",
  "update:sortValue",
  "change",
  "reset",
]);

const filters = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const categoryCodeValue = computed({
  get() {
    const val = filters.value.category_code;
    return val != null && val !== "" ? String(val) : undefined;
  },
  set(value) {
    filters.value.category_code = value;
    emitChange();
  },
});

const statusFilterValue = computed({
  get() {
    const val = filters.value.status;
    return val != null && val !== "" ? String(val) : undefined;
  },
  set(value) {
    filters.value.status = value;
    emitChange();
  },
});

const sortModel = computed({
  get() {
    return props.sortValue || undefined;
  },
  set(value) {
    updateSort(value);
  },
});

function emitChange() {
  emit("change");
}

function updateSort(value) {
  emit("update:sortValue", value);
  emitChange();
}

function resetFilters() {
  emit("reset");
}
</script>

<template>
  <div class="filters">
    <div class="overflow-x-auto">
      <div class="filters-row">
        <Input
          v-model="filters.reg_date"
          type="date"
          :placeholder="$t('Дата сделки')"
          class="filter-select"
          style="min-width: 300px"
          @change="emitChange"
        />
        <Select v-model="categoryCodeValue">
          <SelectTrigger
            class="w-full filter-select"
            @clear="categoryCodeValue = undefined"
          >
            <SelectValue :placeholder="$t('Тип услуги')" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem
              v-for="item in templateCategories"
              :key="item.code"
              :value="String(item.code)"
            >
              {{ item.name }}
            </SelectItem>
          </SelectContent>
        </Select>
        <Select v-model="statusFilterValue">
          <SelectTrigger
            class="w-full filter-select"
            @clear="statusFilterValue = undefined"
          >
            <SelectValue :placeholder="$t('Статус')" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem
              v-for="status in statusOptions"
              :key="status.value"
              :value="String(status.value)"
            >
              {{ status.label }}
            </SelectItem>
          </SelectContent>
        </Select>
        <Select v-model="sortModel">
          <SelectTrigger
            class="w-full filter-select"
            @clear="sortModel = undefined"
          >
            <SelectValue :placeholder="$t('Сортировка')" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="created_at_desc">{{
              $t("Дата создания: новые")
            }}</SelectItem>
            <SelectItem value="created_at_asc">{{
              $t("Дата создания: старые")
            }}</SelectItem>
            <SelectItem value="date_desc">{{
              $t("Дата регистрации: новые")
            }}</SelectItem>
            <SelectItem value="date_asc">{{
              $t("Дата регистрации старые")
            }}</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
    <Button variant="outline" @click="resetFilters">
      {{ $t("Сбросить фильтр") }}
    </Button>
  </div>
</template>

<style scoped lang="scss">
.filters {
  @apply flex justify-between items-center gap-4;
}

.filters-row {
  @apply flex items-center gap-2 w-max;
}

.filter-select {
  min-width: 200px;
}
</style>
